
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {RawLocation} from 'vue-router';

/**
 * Toolbar shared by the route views. On desktop it renders the classic single-row toolbar; on phones and
 * tablets it collapses into a compact bar (back icon + title + actions) and moves the chips to a wrapping row
 * below, so nothing overflows horizontally.
 */
@Component({name: 'RoutePageHeader'})
export default class RoutePageHeader extends Vue {
  @Prop({required: true}) protected title!: string;
  @Prop({default: 'mdi-map-marker-path'}) protected icon!: string;
  @Prop({default: null}) protected backTo!: RawLocation | null;
  @Prop({default: ''}) protected oldBackofficeUrl!: string;
  @Prop({default: false}) protected canAdmin!: boolean;

  protected get compact(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  protected get showOldBackoffice(): boolean {
    return this.canAdmin && !!this.oldBackofficeUrl;
  }
}
